class FelixFeatures extends window.BAO.CustomElement {
  constructor () {
    super()

    this.observeItems()

    if (window.outerWidth < 768) {
      this.carousel = this.initialiseCarousel()
    }

    this.lightsOn = true
  }

  setupListeners () {
    super.setupListeners()

    this.els.switch.elements.forEach(el => {
      this.listeners.add(el, 'click', this.toggleLights.bind(this))
    })
  }

  observeItems () {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.classList.add('sec-FelixFeatures-visible')
          }
        })
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
      }
    )

    observer.observe(this)
  }

  initialiseCarousel () {
    // eslint-disable-next-line new-cap
    const carousel = new window.KeenSlider685(this.els.slides.element, {
      loop: false,
      mode: 'snap',
      rtl: false,
      slides: {
        perView: 1,
        spacing: 0
      }
    })

    carousel.on('slideChanged', () => {
      this.els.slide.elements.forEach((dot, index) => {
        dot.setAttribute('aria-current', carousel.track.details.rel === index)
      })
    })

    return carousel
  }

  toggleLights () {
    this.lightsOn = !this.lightsOn

    this.classList.toggle('sec-FelixFeatures-dark', !this.lightsOn)

    this.els['lights-off'].elements.forEach(el => {
      el.setAttribute('aria-hidden', !this.lightsOn)
    })

    this.els['lights-on'].elements.forEach(el => {
      el.setAttribute('aria-hidden', this.lightsOn)
    })
  }
}

customElements.define('felix-features', FelixFeatures)
